module.exports = __webpack_public_path__ + "img/function-12.5b56d83f.png";